import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=8dcf5fd0&scoped=true"
import script from "./answerSheet.vue?vue&type=script&lang=ts"
export * from "./answerSheet.vue?vue&type=script&lang=ts"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=8dcf5fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcf5fd0",
  null
  
)

export default component.exports